import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    CardImg,
    CardBody,
    CardText,
    Badge,
    Spinner
} from "reactstrap";
import "./style.scss"
import { useSelector ,useDispatch } from "react-redux"
import location from "assets/images/location.png"
import building from "assets/images/building-icon.png"
import arrow from "assets/images/arrow.png"
import developerdImg from "assets/images/developer_logo.png";
import "assets/scss/website/app.scss";
import compoundImg from "assets/images/bg.png"
import { useTranslation } from 'react-i18next';
import InterestServices from "services/Website/InterestServices";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import { appendFilters } from "store/actions";
import { toast } from "react-toastify";
import { addInterest } from "store/Auth/actions";
import CallModal from "../Modal/CallModal";
import MessageModal from "../Modal/MessageModal";
import Spinner2 from "components/Website/Spinner2";

const UserMode = ({ developer, city, address, area, compound, history, allUnits, setShowInteractive}) => {
    const [activeCanvas, setActiveCanvas] = useState(null)
    const [canvas, setCanvas] = useState('');
    const [callModal, setCallModal] = useState(false);
    const [callTypeModal, setCallTypeModal] = useState('');
    const [toolTipData, setToolTipData] = useState('');
    const [phone, setPhone] = useState('');
    const [messageModal, setMessageModal] = useState(false);
    const [unit, setUnit] = useState('');
    const [activeCardImg, setActiveCardImg] = useState('');
    const { t } = useTranslation();
    const modeData = useSelector(state => state.Mode)
    const [openImage, setOpenImage] = useState(0)
    const [interestLoading, setInterestLoading] = useState(false)
    const interestServices = new InterestServices()
    const AuthData = useSelector(state => state.Auth)
    const dispatch = useDispatch()

    const isInterested = (idData) => {
      const id = parseInt(idData)
      return AuthData.interestsUnits.includes(id)
    }
    
    const interestHandler = (id) => {
        const data = { unit_id: id }
        setInterestLoading(true)
        if (!AuthData.interestsUnits.includes(id)){
          interestServices.createInterest(data).then(response => {
            if (response && response.status === SuccessCreated) {
              toast.success("Unit Added to Your Interests Successfully")
              dispatch(addInterest({ interestsUnits: [...AuthData.interestsUnits, id] }))
              setInterestLoading(false)
            }
          })
        } else {
          interestServices.deleteInterest(data).then(response => {
            if (response && response.status === SuccessOk) {
              toast.success("Unit removed from Your interests")
              const updatedInterests = AuthData.interestsUnits.filter(data => data !== id)
              dispatch(addInterest({ interestsUnits: updatedInterests }))
              setInterestLoading(false)
            }
          })
        }
    }

    useEffect(()=>{
        document.body.style.overflow = 'hidden';
    },[])
    // useEffect(() => {
    //     setFlag(c => c + 1)
    //     if (activeCanvas ?.constrains ?.type !== "unit" ) {
    //         setImages(activeCanvas ?.images)
    //     }
    // }, [activeCanvas])

    function toggleFullscreen() {
        setShowInteractive(false)
        document.body.style.overflow = 'auto';
    }
    // function toggleFullscreenn() {
    //     setFullScreen(false)
    //     if (
    //         !document.fullscreenElement &&
    //       /* alternative standard method */ !document.mozFullScreenElement &&
    //         !document.webkitFullscreenElement
    //     ) {
    //         // current working methods
    //         if (document.documentElement.requestFullscreen) {
    //             document.documentElement.requestFullscreen()
    //         } else if (document.documentElement.mozRequestFullScreen) {
    //             document.documentElement.mozRequestFullScreen()
    //         } else if (document.documentElement.webkitRequestFullscreen) {
    //             document.documentElement.webkitRequestFullscreen(
    //                 Element.ALLOW_KEYBOARD_INPUT
    //             )
    //         }
    //     } else {
    //         if (document.cancelFullScreen) {
    //             document.cancelFullScreen()
    //         } else if (document.mozCancelFullScreen) {
    //             document.mozCancelFullScreen()
    //         } else if (document.webkitCancelFullScreen) {
    //             document.webkitCancelFullScreen()
    //         }
    //     }
    //     document.body.classList.add("no-scroll")
    // }

    const initCanvas = () => {
        const canvas = new fabric.Canvas(`canvas`)
        // canvas.setDimensions({ width: 1260, height: 772 })
        canvas.setDimensions({ width: 661.5, height: 398 })

        // background image shoulf reset with every change in the canvas  
        // (chexk it in admin page)
        // new fabric.Image.fromURL(activeCanvas ?.path, function (img) {
        //     canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
        //         scaleX: canvas.width / img.width,
        //         scaleY: canvas.height / img.height
        //     });
        // })
        return canvas
    }

    useEffect(() => {
        setCanvas(initCanvas());
    }, []);

    useEffect(() => {
        const image = modeData.images.find(img => img?.id === modeData.masterImg?.id)
        let updateShapes
        // if(!modeData.images?.filter(res=> res.title == 'layer')?.length > 0){
        //     updateShapes = modeData?.images?.filter(res=> res?.comesForm?.id == image?.id)
        // }else{
        // }
        updateShapes = image?.shapes?.filter(img=> {
            if(img.hotspot?.type == 'unit'){
                let isExist = allUnits.filter(unit => unit.id == img?.hotspot.id)
                if(isExist.length > 0){
                    return img
                }
            } else {
                let isExist = allUnits?.filter(unit => img?.hotspot?.units?.some(res=> res == unit.id))
                if(isExist.length > 0){
                    return img
                }
            }
        })
        setActiveCanvas({...image , shapes: updateShapes})
    }, [modeData])

    const renderSavedCanvasData = async (activeCanvas) => {
        let loader = document.getElementById('loader')
        if (canvas !== "") {
            loader.style.display= 'block'
            await canvas ?.clear()
            await canvas ?.renderAll();
            //  myStateRef.current = activeCanvas
            new fabric.Image.fromURL(activeCanvas ?.path, function (img) {
                canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
                    originX: 'left',
                    scaleX: canvas.getWidth() / img.width,   //new update
                    scaleY: canvas.getHeight() / img.height,   //new update
                    originY: 'top',
                });
                loader.style.display= 'none'
            })

            fabric.Canvas.prototype.setCursor
                = function (value) {
                    value = 'pointer'; // Add your own logic here to override
                    this.upperCanvasEl.style.cursor = value;
                };
           if(activeCanvas?.constrains?.type!=="unit" ){
            activeCanvas ?.shapes ?.forEach((shape, index) => {
                if(shape.hotspot?.type === "unit"){
                    if(shape.hotspot.data.sale_status === "Left"){
                        let shapeData = {
                            ...shape,
                            // left: shape.left * 1.9,
                            // top: shape.top * 1.95,
                            // width: shape.width * 1.5,
                            // height: shape.height * 1.5,
                        }
                        if (shape.type === "Circle") {
                            const text = new fabric.Text(shape?.title, {
                                fill: 'white',
                                left: shape.left + ((shape.aCoords?.tr?.x - shape.aCoords?.tl?.x) / 2),
                                top: shape.top - 10,
                                // left: shape.left * 1.91,
                                // top: shape.top * 2.03 -35,
                                fontSize: 14,
                                type: "text",
                                hotspot: {
                                    type: "none"
                                }
        
                            });
                            text.set('selectable', false)
                            canvas.add(text);

                            shapeData = {
                                ...shape,
                                // left: shape.left,
                                top: shape.top+10,
                                // radius: shape.radius * 2.4,
                                // padding: 30,
                                // aCoords: {
                                //     b1: {
                                //         x: shape.aCoords.bl.x * widthPercent,
                                //         y: shape.aCoords.bl.y * heightPercent,
                                //     }, br: {
                                //         x: shape.aCoords.br.x * widthPercent,
                                //         y: shape.aCoords.br.y * heightPercent,
                                //     }, t1: {
                                //         x: shape.aCoords.tl.x * widthPercent,
                                //         y: shape.aCoords.tl.y * heightPercent,
                                //     }, tr: {
                                //         x: shape.aCoords.tr.x * widthPercent,
                                //         y: shape.aCoords.tr.y * heightPercent
                                //     }
        
                                // },
                                stroke:0,
                                scaleX : shape.scaleX *.8,
                                scaleY: shape.scaleY *.8,
                                // width : shape.width,
                                // height: shape.height ,
                            }
                            var circle = new fabric.Circle({ ...shapeData, fill: "rgba(255,255,255,.4)" });
                            circle.set('selectable', false)
                            // var group = new fabric.Group([circle, text], { ...shapeData })
                            canvas.add(circle);
                        } else if (shape.type === "Rect") {
                            const text = new fabric.Text(shape?.title, {
                                fill: 'white',
                                // left: shape.left * 1.95,
                                // top: shape.top * 3.5 - 30,
                                left: shape.left + ((shape.aCoords?.tr?.x - shape.aCoords?.tl?.x) / 2),
                                top: shape.top - 10,
                                fontSize: 14,
                                type: "text",
                                hotspot: {
                                    type: "none"
                                }
                            });
                            text.set('selectable', false)
                            canvas.add(text);
                            shapeData = {
                                ...shape,
                                // scaleX: shape.scaleX,
                                // scaleY: shape.scaleY,
                                // left: shape.left,
                                // top: shape.top,

                                // padding: 30
                                // left: shape.left * 1.95,
                                // top: shape.top * 3.5,
                            }
                            var rect = new fabric.Rect({ ...shapeData, fill: "rgba(255,255,255,.4)", stroke: 0  });
                            rect.set('selectable', false)
        
                            canvas.add(rect);
                        } else if (shape.type === "Cubic") {
                            const text = new fabric.Text(shape?.title, {
                                fill: 'white',
                                left: shape.left + ((shape.aCoords?.tr?.x - shape.aCoords?.tl?.x) / 2),
                                top: shape.top - 5,
                                fontSize: 14,
                                type: "text",
                                hotspot: {
                                    type: "none"
                                }
                            });
                            text.set('selectable', false)
                            canvas.add(text);
                            shapeData = {
                                ...shape,
                                // scaleX: shape.scaleX,
                                // scaleY: shape.scaleY,
                                // left: shape.left,
                                // top: shape.top,

                                // padding: 30
                                // left: shape.left * 1.95,
                                // top: shape.top * 3.5,
                            }
                            var rect = new fabric.Rect({ ...shapeData });
                            rect.set('selectable', false)
        
                            canvas.add(rect);
                        } else if (shape.type === "Pin") {
                            const text = new fabric.Text(shape?.title, {
                                fill: 'white',
                                left: shape.left,
                                top: shape.top -7.5,
                                // left: shape.left * 2,
                                // top: shape.top * 2.45 -15,
                                fontSize: 14,
                                type: "text",
                                hotspot: {
                                    type: "none"
                                }
        
                            });
                            text.set('selectable', false)
                            canvas.add(text);
                            
                            shapeData = {
                                ...shape,

                                scaleX: shape.scaleX * .1,
                                scaleY: shape.scaleY * .1,
                                // left: shape.left ,
                                top: shape.top +7.5 ,
                                // padding: 50,
                                // aCoords: {
                                //     b1: {
                                //         x: shape.aCoords.bl.x * 2.33,
                                //         y: shape.aCoords.bl.y * 2.4125,
                                //     }, br: {
                                //         x: shape.aCoords.br.x * 2.33,
                                //         y: shape.aCoords.br.y * 2.4125,
                                //     }, t1: {
                                //         x: shape.aCoords.tl.x * 2.33,
                                //         y: shape.aCoords.tl.y * 2.4125,
                                //     }, tr: {
                                //         x: shape.aCoords.tr.x * 2.33,
                                //         y: shape.aCoords.tr.y * 2.4125
                                //     }
        
                                // },
                                // zoomX: shape.zoomX * 2,
                                // zoomY: shape.zoomY * 2,
                                // scaleX: shape.scaleX * 1.5,
                                // scaleY: shape.scaleY * 1.55,
                            }

                            fabric.Image.fromURL(location, function (img) {
                                img.scale(0.1).set({
                                    ...shapeData
                                })
        
                                canvas.add(img)
                            })
                        } else if (shape.type === "Build") {
                            const text = new fabric.Text(shape?.title, {
                                fill: 'white',
                                // left: shape.left * 1.9,
                                // top: shape.top * 1.95 -30,
                                left: shape.left + 5,
                                top: shape.top - 5,
                                fontSize: 14,
                                type: "text",
                                hotspot: {
                                    type: "none"
                                }
        
                            });
                            text.set('selectable', false)
                            canvas.add(text);
                            
                            shapeData = {
                                ...shape,
                                // left: shape.left * 1.9,
                                top: shape.top +13,
                                scaleX: shape.scaleX * .1,
                                scaleY: shape.scaleY * .1,
                                // aCoords: {
                                //     b1: {
                                //         x: shape.aCoords.bl.x * 2.33,
                                //         y: shape.aCoords.bl.y * 2.4125,
                                //     }, br: {
                                //         x: shape.aCoords.br.x * 2.33,
                                //         y: shape.aCoords.br.y * 2.4125,
                                //     }, t1: {
                                //         x: shape.aCoords.tl.x * 2.33,
                                //         y: shape.aCoords.tl.y * 2.4125,
                                //     }, tr: {
                                //         x: shape.aCoords.tr.x * 2.33,
                                //         y: shape.aCoords.tr.y * 2.4125
                                //     }
        
                                // },
                                // zoomX: shape.zoomX * 2.33,
                                // zoomY: shape.zoomY * 2.4125,
                            }

                            fabric.Image.fromURL(building, function (img) {
                                img.scale(0.1).set({
                                    ...shapeData
                                })
        
                                canvas.add(img)
                            })
                        } else if (shape.type === "Arrow") {
                            const text = new fabric.Text(shape?.title, {
                                fill: 'white',
                                left: shape.left + 10,
                                top: shape.top -5,
                                fontSize: 14,
                                type: "text",
                                hotspot: {
                                    type: "none"
                                }
        
                            });
                            text.set('selectable', false)
                            canvas.add(text);
                            shapeData = {
                                ...shape,
                                // left: shape.left * 1.9,
                                top: shape.top +13,
                                // aCoords: {
                                //     b1: {
                                //         x: shape.aCoords.bl.x * 2.33,
                                //         y: shape.aCoords.bl.y * 2.4125,
                                //     }, br: {
                                //         x: shape.aCoords.br.x * 2.33,
                                //         y: shape.aCoords.br.y * 2.4125,
                                //     }, t1: {
                                //         x: shape.aCoords.tl.x * 2.33,
                                //         y: shape.aCoords.tl.y * 2.4125,
                                //     }, tr: {
                                //         x: shape.aCoords.tr.x * 2.33,
                                //         y: shape.aCoords.tr.y * 2.4125
                                //     }
        
                                // },
                                // zoomX: shape.zoomX * 2.33,
                                // zoomY: shape.zoomY * 2.4125,
                                scaleX: shape.scaleX * 0.065,
                                scaleY: shape.scaleY * 0.065,
                            }
                            fabric.Image.fromURL(arrow, function (img) {
                                img.scale(0.065).set({
                                    ...shapeData
                                })
        
                                canvas.add(img)
                            })
                        } else {
                            shapeData = {
                                ...shape,
                                // left: shape.left+20.5,
                                top: shape.top + 7.5,
                                // padding: 5,
                                // aCoords: {
                                //     bl: {
                                //         x: shape.left +3,
                                //         y: shape.aCoords.bl.y + (shape.aCoords.bl.y - shape.aCoords.tl.y),
                                //     }, br: {
                                //         x: shape.aCoords.br.x + (shape.aCoords.br.x - shape.aCoords.bl.x),
                                //         y: shape.aCoords.br.y + (shape.aCoords.bl.y - shape.aCoords.tl.y),
                                //     }, tl: {
                                //         x: shape.left +3,
                                //         y: shape.top + 10,
                                //     }, tr: {
                                //         x: shape.aCoords.tr.x + (shape.aCoords.tr.x - shape.aCoords.tl.x),
                                //         y: shape.top + 10
                                //     }
        
                                // },
                                // zoomX: shape.zoomX * 1.2,
                                // zoomY: shape.zoomY * 1.2,
                                // scaleX: shape.scaleX,
                                // scaleY: shape.scaleY,
                                // width: shape.aCoords?.tr.x - shape.aCoords?.tl.x,
                                // height: shape.aCoords?.br.y - shape.aCoords?.tr.y,
                                // scaleX: shape.scaleX * .85,
                                // scaleY: shape.scaleY * .85,
        
                            }

                            var node = new fabric.Circle({
                                ...shape,
                                radius: 20,
                                fill: shape?.fill,
                                stroke: shape?.fill,
                                strokeWidth: 1,
                                top: shape.top+14
                            });
                            // var nodeChild = new fabric.Circle({
                            //     radius: 10,
                            //     fill: '#fd3d3d',
                            //     left: 10,
                            //     top: 41,
                            // });
                            const text = new fabric.Text(shape?.title, {
                                fill: 'white',
                                left: shape.left+3,
                                top: shape.top,
                                fontSize: 14,
                                type: "text",
                                height: 7.5,
                                hotspot: {
                                    type: "none"
                                },
                                selectable: false,
                            });
                            canvas.add(text);
                            // var group = new fabric.Group([node, nodeChild], { ...shapeData })
                            node.set('selectable', false)

                            canvas.add(node);
                        }
                    }
                }else{
                    let shapeData = {
                        // ...shape,
                        // left: shape.left * 1.9,
                        // top: shape.top * 1.95,
                        // width: shape.width * 1.9,
                        // height: shape.height * 1.95,
                    }
                    if (shape.type === "Circle") {
                        const text = new fabric.Text(shape?.title, {
                            fill: 'white',
                            left: shape.left + ((shape.aCoords?.tr?.x - shape.aCoords?.tl?.x) / 2),
                            top: shape.top-13,
                            fontSize: 14,
                            type: "text",
                            hotspot: {
                                type: "none"
                            }
    
                        });
                        text.set('selectable', false)
                        canvas.add(text);
                        shapeData = {
                            ...shape,
                            fill: "rgba(255,255,255,.4)", 
                            strokeWidth: 0,
                            // left: shape.left,
                            // top: shape.top ,
                            // scaleX : 1,
                            // scaleY: shape.scaleY * .93,
                            // scaleX: shape.scaleX ,
                            // scaleY: shape.scaleY,
                            // radius: shape.radius * 2.4,
                        }

                        var circle = new fabric.Circle({ ...shapeData });
                        circle.set('selectable', false)
                        // var group = new fabric.Group([circle, text], { ...shapeData })
                        canvas.add(circle);
                    } else if (shape.type === "Rect") {
                        const text = new fabric.Text(shape?.title, {
                            fill: 'white',
                            left: shape.left + ((shape.aCoords?.tr?.x - shape.aCoords?.tl?.x) / 2),
                            top: shape.top -13,
                            fontSize: 14,
                            type: "text",
                            hotspot: {
                                type: "none"
                            }
    
                        });
                        text.set('selectable', false)
                        canvas.add(text);
                        shapeData ={
                            ...shape,
                            strokeWidth: 0,
                            fill: "rgba(255,255,255,.4)",
                            // scaleY: shape.scaleY * .93,
                            // scaleX: shape.scaleX * .55,
                            // scaleY: shape.scaleY * .55,
                            // left: shape.left + 10,
                            // top: shape.top + 20,
                        }
                        var rect = new fabric.Rect({ ...shapeData});
                        rect.set('selectable', false)
    
                        canvas.add(rect);
                    } else if (shape.type === "Cubic") {
                        const text = new fabric.Text(shape?.title, {
                            fill: 'white',
                            left: shape.left + ((shape.aCoords?.tr?.x - shape.aCoords?.tl?.x) / 2),
                            top: shape.top - 7.5,
                            fontSize: 14,
                            type: "text",
                            hotspot: {
                                type: "none"
                            }
                        });
                        text.set('selectable', false)
                        canvas.add(text);
                        shapeData = { 
                            ...shape,
                            stroke: shape?.fill,
                            top: shape.top+7
                        }
                        var rect = new fabric.Rect({ ...shapeData });
                        rect.set('selectable', false)
    
                        canvas.add(rect);
                    } else if (shape.type === "Pin") {
                        const text = new fabric.Text(shape?.title, {
                            fill: 'white',
                            left: shape.left,
                            top: shape.top - 3,
                            fontSize: 14,
                            type: "text",
                            hotspot: {
                                type: "none"
                            }
    
                        });
                        text.set('selectable', false)
                        canvas.add(text);

                        shapeData = {
                            ...shape,
                            scaleX: shape.scaleX * .1,
                            scaleY: shape.scaleY * .1,
                            left: shape.left,
                            top: shape.top + 9,
                            // padding: 50,
                            // aCoords: {
                            //     b1: {
                            //         x: shape.aCoords.bl.x * 2.33,
                            //         y: shape.aCoords.bl.y * 2.4125,
                            //     }, br: {
                            //         x: shape.aCoords.br.x * 2.33,
                            //         y: shape.aCoords.br.y * 2.4125,
                            //     }, t1: {
                            //         x: shape.aCoords.tl.x * 2.33,
                            //         y: shape.aCoords.tl.y * 2.4125,
                            //     }, tr: {
                            //         x: shape.aCoords.tr.x * 2.33,
                            //         y: shape.aCoords.tr.y * 2.4125
                            //     }
                            // },
                            // zoomX: shape.zoomX * 2.33,
                            // zoomY: shape.zoomY * 2.4125,
                            // scaleX: shape.scaleX * 1.5,
                            // scaleY: shape.scaleY * 1.55,
                        }
                        fabric.Image.fromURL(location, function (img) {
                            img.scale(0.1).set({
                                ...shapeData
                            })
    
                            canvas.add(img)
                        })
                    } else if (shape.type === "Build") {
                        const text = new fabric.Text(shape?.title, {
                            fill: 'white',
                            left: shape.left + 10,
                            top: shape.top -8,
                            fontSize: 14,
                            type: "text",
                            hotspot: {
                                type: "none"
                            },
                            selectable: false
    
                        });
                        canvas.add(text);
                        shapeData = {
                            ...shape,
                            // left: shape.left * 1.9,
                            top: shape.top +13,
                            // padding: 50,
                            // aCoords: {
                            //     b1: {
                            //         x: shape.aCoords.bl.x * 2.33,
                            //         y: shape.aCoords.bl.y * 2.4125,
                            //     }, br: {
                            //         x: shape.aCoords.br.x * 2.33,
                            //         y: shape.aCoords.br.y * 2.4125,
                            //     }, t1: {
                            //         x: shape.aCoords.tl.x * 2.33,
                            //         y: shape.aCoords.tl.y * 2.4125,
                            //     }, tr: {
                            //         x: shape.aCoords.tr.x * 2.33,
                            //         y: shape.aCoords.tr.y * 2.4125
                            //     }
                            // },
                            // zoomX: shape.zoomX * 2.33,
                            // zoomY: shape.zoomY * 2.4125,
                            scaleX: shape.scaleX * .1,
                            scaleY: shape.scaleY * .1,
                        }
                        fabric.Image.fromURL(building, function (img) {
                            img.scale(0.1).set({
                                ...shapeData
                            })
    
                            canvas.add(img)
                        })
                    } else if (shape.type === "Arrow") {
                        const text = new fabric.Text(shape?.title, {
                            fill: 'white',
                            left: shape.left + 10,
                            top: shape.top-5,
                            fontSize: 14,
                            angle: shape.angle,
                            type: "text",
                            hotspot: {
                                type: "none"
                            }
                        });
                        text.set('selectable', false)
                        canvas.add(text);
                        shapeData = {
                            ...shape,
                            stroke: 0,
                            hoverCursor: 'cursor',
                            // left: shape.left * 1.9,
                            top: shape.top +13,
                            // zoomX: shape.zoomX * 2.33,
                            // zoomY: shape.zoomY * 2.4125,
                            scaleX: shape.scaleX * .065,
                            scaleY: shape.scaleY * .065,
                        }
                        fabric.Image.fromURL(arrow, function (img) {
                            img.scale(0.065).set({
                                ...shapeData
                            })
    
                            canvas.add(img)
                        })
                    } else {
                        var node = new fabric.Circle({
                            ...shape,
                            radius: 20,
                            fill: shape?.fill,
                            stroke: shape?.fill,
                            strokeWidth: 1,
                            top: shape.top+14
                        });
                        
                        const text = new fabric.Text(shape?.title, {
                            fill: 'white',
                            left: shape.left + 3,
                            top: shape.top,
                            fontSize: 14,
                            type: "text",
                            hotspot: shape.hotspot,
                            selectable: false,
                        });
                        canvas.add(text);
                        node.set('selectable', false)
    
                        canvas.add(node);
                    }
                }
            })
           } 
            canvas.renderAll();
        }
    }

    useEffect(() => {
        if (canvas !== "") {
            canvas.on('mouse:over', function (e) {
                let element = document.getElementById('canvas');
                let positionInfo = element.getBoundingClientRect();
                let canvasHeight = positionInfo.height;
                let canvasWidth = positionInfo.width;
                const value = e.target

                if (value) {
                    const tt = document.getElementById("toolTip")
                    if (value.type !== "text") {
                        setActiveCardImg(value?.idImage?.path)
                        setToolTipData(value ?.hotspot)

                        if (value.hotspot.type === "none") {
                            setToolTipData({
                                title: value.title,
                                ...value ?.hotspot
                            })

                        } else {
                            setToolTipData(value ?.hotspot)
                        }
                        tt.style.visibility = 'visible'
                    }

                    let left = e.target.left
                    let top = e.target.top
                    let width = Math.abs(value.aCoords.tr.x - value.aCoords.tl.x)
                    let height = Math.abs(value.aCoords.tr.y - value.aCoords.br.y)
                    let shapeTop = value.aCoords.tl.y * (canvasHeight/ 398)
                    let shapeLeft = value.aCoords.tr.x * (canvasWidth/ 661.5)
                    let heightPercent = canvasHeight/ 398
                    let widthPercent = canvasWidth/ 661.5

                    if (left <= 330){
                        let leftVal = (left + width) * widthPercent
                        tt.style.left = `${leftVal +20}px`
                    } else {
                        let leftVal = left * widthPercent
                        tt.style.left = `${leftVal - 255}px`
                    }
                    if (top <= 199) {
                        tt.style.top = `${top > 99.5 ? shapeTop-150 : Math.abs(shapeTop -75)}px`
                    } else {
                        tt.style.top = `${shapeTop - 340 < 0 ? 20 : shapeTop - 340}px`
                    }

                    // if (value.type === "Pin") {
                    //     if ((661 - left - 100) >= 330) {
                    //         tt.style.left = `${left + 100}px`
                    //     } else {
                    //         tt.style.right = `${left + 100}px`
                    //     }
                    //     if ((398 - top - 70) >= 199) {
                    //         tt.style.top = `${top + 70}px`
                    //     } else {
                    //         tt.style.bottom = `${top + 70}px`
                    //     }
                    // } else if (value.type === "Build" || value.type === "Arrow") {
                    //     if ((661 - left - width / 2) >= 330) {
                    //         tt.style.left = `${left + (value.aCoords.tr.x - value.aCoords.tl.x) * 1.2}px`
                    //     } else {
                    //         tt.style.left = `${left - 150}px`
                    //     }
                    //     if ((398 - top - 70) >= 199) {
                    //         tt.style.top = `${top-100}px`
                    //     } else {
                    //         tt.style.bottom = `${300}px`
                    //     }
                    //     // if (left <= 330){
                    //     //     tt.style.left = `${(value.aCoords.tr.x * (canvasWidth/ 661.5)) + ((value.aCoords.tr.x -value.aCoords.tl.x) /2) }px`
                    //     // } else {
                    //     //     tt.style.right = `${661.5 - (value.aCoords.tl.x * (canvasWidth/ 661.5)) + ((value.aCoords.tr.x -value.aCoords.tl.x) /2) }px`
                    //     // }
                    //     // if (top <= 199) {
                    //     //     // tt.style.left = `${value.aCoords.tr.x*2.4}px`
                    //     //     tt.style.top = `${(value.aCoords.tb.x * (canvasHeight/ 398)) + (value.aCoords.tr.x -value.aCoords.br.x) }px`
                    //     // } else {
                    //     //     tt.style.bottom = `${(value.aCoords.tl.x * (canvasHeight/ 398)) + (value.aCoords.tr.x -value.aCoords.br.x) }px`
                    //     // }
                    // } else if (value.type == "node") {
                    //     let width = value.aCoords.br.x - value.aCoords.bl.x
                    //     let height = value.aCoords.br.y - value.aCoords.tr.y
                    //     if ((661 - left - width / 2) >= 330){
                    //         tt.style.left = `${left + width * 1.5}px`
                    //     } else {
                    //         tt.style.left = `${left - 150}px`
                    //     }
                    //     if ((398 - top - height / 2) >= 199){
                    //         tt.style.top = `${top - height }px`
                    //     } else {
                    //         tt.style.bottom = `${300}px`
                    //     }

                    // } else {
                    //     if ((661 - left - width / 2) >= 330) {
                    //         tt.style.left = `${left + width / 2}px`
                    //     } else {
                    //         tt.style.right = `${(left + width / 2) -290}px`
                    //     }
                    //     if ((398 - top - height / 2) >= 199) {
                    //         tt.style.top = `${top + height / 2}px`
                    //     } else {
                    //         tt.style.bottom = `${top + height / 2}px`
                    //     }  
                    // }
                }
            })
            canvas.on('mouse:out', function (e) {
                const value = e.target

                if (value) {
                    const tt = document.getElementById("toolTip")
                    if (e.target) {
                        tt.style.visibility = 'hidden'
                    }
                }

            })
            canvas.on('mouse:down', function (e) {
                const value = e.target
                if (value) {
                    const tt = document.getElementById("toolTip")
                    tt.style.visibility = 'hidden'

                    const navigateTo = value.idImage?.id
                    const canvasTarget = modeData.images.find(item => {
                        return item?.id === parseInt(navigateTo)
                    })
                    if(!canvasTarget){
                        return
                    }
                    let updateShapes 
                    
                    if(!!canvasTarget?.shapes?.length && canvasTarget?.shapes?.filter(res=> res.hotspot.type == 'layer')?.length > 0){
                        updateShapes = canvasTarget?.shapes
                    } else {
                        updateShapes = !!canvasTarget?.shapes?.length ? canvasTarget?.shapes?.filter(res=> allUnits.some(unit=> unit.id == res.hotspot.id)) : ''
                    }
                    setActiveCanvas({ ...canvasTarget, shapes: [...updateShapes] })
                }
            });
        }
    }, [canvas])

    useEffect(() => {
        renderSavedCanvasData(activeCanvas)
    }, [activeCanvas])

    return (
        <>
        <Row className="interactive-mode" style={{overflow: 'hidden'}}>
            <Col md='12' className="my-2 d-flex justify-content-between" style={{padding: '0 2rem'}}>
                <div>
                    {modeData?.masterImg?.id !== activeCanvas?.id && <button className="btn btn-light" 
                    style={{ marginRight: '8px'}}
                     onClick={() => {
                        const canvasTarget = modeData.images.find(item => {
                            if(!activeCanvas.comesForm?.id){
                                return item?.id === modeData.masterImg?.id
                            }
                            return item?.id === activeCanvas.comesForm?.id
                        })
                        let updateShapes
                        if(!!canvasTarget?.shapes && canvasTarget?.shapes?.filter(res=> res.title == 'layer')?.length > 0){
                            updateShapes = canvasTarget.shapes
                        } else{
                            updateShapes = canvasTarget?.shapes?.filter(img=> {
                                if(img.hotspot?.type == 'unit'){
                                    let isExist = allUnits.filter(unit => unit.id == img?.hotspot.id)
                                    if(isExist.length > 0){
                                        return img
                                    }
                                } else {
                                    let isExist = allUnits.filter(unit => img?.hotspot?.units?.some(res=> res == unit.id))
                                    if(isExist.length > 0){
                                        return img
                                    }
                                }
                            })
                        }
                        
                        setActiveCanvas({ ...canvasTarget, shapes: updateShapes })
                    }} >
                        <i className="fas fa-chevron-left"></i>
                    </button> }
                  
                    <button className="btn btnMessage text-center"
                            
                        onClick={(e) => {
                            e.stopPropagation() 
                            setCallModal(true)
                            if(activeCanvas ?.constrains ?.type === "unit"){
                                setCallTypeModal('unit')
                                let unit = allUnits?.filter(unit=> unit.id == toolTipData.id)
                                let sales_rep = unit[0].sales_rep
                                setPhone(sales_rep?.phone)
                            } else {
                                setCallTypeModal('compound')
                                setPhone(compound?.sales_rep?.phone)
                            }
                        }} >
                            <i className="fas fa-phone-alt"></i> {t("call")}
                    </button>
                    <button className="btn btnMessage text-center mx-2" onClick={(e) => {
                                e.stopPropagation()
                                if(activeCanvas ?.constrains ?.type === "unit"){
                                    setCallTypeModal('unit')
                                    setMessageModal(true)
                                    setUnit(activeCanvas.constrains.data)
                                } else {
                                    setCallTypeModal('compound')
                                    setMessageModal(true)
                                    setUnit(compound)
                                }
                            }}  >
                                <i className="fa fa-envelope"></i> {t("Message")}
                    </button>
                
                </div>
                <div>
                    <button className="btn btn-danger"
                    onClick={() => { 
                        toggleFullscreen() 
                    }}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </Col>

            <Col className="active position-relative " md={12}>
                <div id="toolTip" className="p-0" style={{ height: toolTipData ?.type === "building" ? "340px" : "365px"}} >
                    {/* {toolTipData} */}
                    <div className="websitPages"  >
                        <div>
                            {toolTipData ?.type === "none" ?
                                <Card className="comCard">
                                    {activeCardImg ?
                                        <CardImg src={activeCardImg} ></CardImg>
                                        :
                                        <CardImg src={compoundImg}  ></CardImg>
                                    }
                                    <CardBody style={{ minHeight: "180px" }}>
                                        <CardText tag="h4" className="font-size-16  " style={{ color: "#3a3335", fontWeight: 800 }}>{toolTipData ?.title}</CardText>
                                        <Row className="d-flex justify-content-between align-items-center m-0">
                                            <Col md={6} className="p-0 fw-bold mb-2">{t("developer")}</Col>
                                            <Col md={6} className="fw-bold d-flex justify-content-end p-0">
                                                {developer ?.name[`${AuthData.lang}`] ?
                                                    developer ?.name[`${AuthData.lang}`] :
                                                        developer ?.name ?.en  
                                                      }
                                            </Col>
                                            {t("none hotspot")}
                                        </Row>
                                    </CardBody>
                                </Card>
                                : toolTipData ?.type === "building" ?
                                    <Card className="comCard">
                                        {activeCardImg ?
                                            <CardImg src={activeCardImg} ></CardImg>
                                            :
                                            <CardImg src={compoundImg}  ></CardImg>
                                        }

                                        {developer ?.media ?.path ? <img src={developer.media.path} className='imgAbsolute' /> :
                                            <img src={developerdImg} className='imgAbsolute' />}
                                        <CardBody style={{ minHeight: "180px" }}>
                                            <CardText tag="h4" className="font-size-16  " style={{ color: "#3a3335", fontWeight: 800 }}>{toolTipData ?.data ?.name[`${AuthData.lang}`] ? toolTipData ?.data ?.name[`${AuthData.lang}`] : toolTipData ?.data ?.name ?.en }</CardText>
                                            <Row className="px-2">
                                            <Col md={6} className="p-0 fw-bold mb-2">
                                                <span className="text-muted font-size-14 pe-2 " style={{ opacity: .4 }}>{t("starting from")} </span>
                                            </Col>
                                            <Col md={6} className='fw-bold d-flex justify-content-end p-0'>
                                                <span className="font-size-16 text-decoration-underline">{toCurrency(toolTipData ?.data ?.starting_from)}  {t("egp")}</span>
                                            </Col>
                                            <Col md={12} className="p-0 fw-bold mb-2" style={{ opacity: .4 }}> 
                                                {toolTipData ?.data ?.installment ? t("up to installment", { num: toolTipData ?.data ?.installment}) : t("only cash")} 
                                            </Col>
                                            <Col md={6} className="p-0 fw-bold mb-2">
                                                <span className="font-size-14 pe-2 ">{t("developer")} </span>
                                            </Col>
                                            <Col md={6} className='fw-bold d-flex justify-content-end p-0'>
                                                <span className="font-size-14 text-decoration-underline">{developer ?.name[`${AuthData.lang}`] ? developer ?.name[`${AuthData.lang}`] :
                                                            developer ?.name ?.en}</span>
                                            </Col>
                                            <Col md={6} className="p-0 fw-bold mb-2">
                                                <span className="font-size-14 pe-2 ">{t("Available Units")} </span>
                                            </Col>
                                            <Col md={6} className='fw-bold d-flex justify-content-end p-0'>
                                                <span className="font-size-14 text-decoration-underline">{toolTipData?.data?.units_count}</span>
                                            </Col>
                                            </Row>

                                            {toolTipData ?.data ?.unit_types?.filter((obj, index, self) => {
                                                return index === self.findIndex((o) => o.en === obj.en);
                                            })?.map((unit, index) => {
                                                return (
                                                    <Badge key={index} className="bgBadge font-size-12">{unit[`${AuthData.lang}`] ? unit[`${AuthData.lang}`] : unit ?.en}</Badge>
                                                )
                                            })}
                                        </CardBody>
                                    </Card>
                                : toolTipData ?.type === "layer" ?
                                    <Card className="comCard">
                                        {activeCardImg ?
                                            <CardImg src={activeCardImg} ></CardImg>
                                            :
                                            <CardImg src={compoundImg}  ></CardImg>
                                        }
  
                                        {developer ?.media ?.path ? <img src={developer.media.path} className='imgAbsolute' /> :
                                            <img src={developerdImg} className='imgAbsolute' />}
                                        <CardBody style={{ minHeight: "180px" }}>
                                            <CardText tag="h4" className="font-size-16  " style={{ color: "#3a3335", fontWeight: 800 }}>{toolTipData ?.label}</CardText>
                                            <Row className="px-2">
                                                <Col md={6} className="p-0 fw-bold mb-2">
                                                    <span className="text-muted font-size-14 pe-2 " style={{ opacity: .4 }}>{t("starting from")} </span>
                                                </Col>
                                                <Col md={6} className='fw-bold d-flex justify-content-end p-0'>
                                                    <span className="font-size-16 text-decoration-underline">{toCurrency(toolTipData ?.data ?.starting_from)}  {t("egp")}</span>
                                                </Col>
                                                <Col md={12} className="p-0 fw-bold mb-2" style={{ opacity: .4 }}> 
                                                    {toolTipData ?.data ?.installment ? t("up to installment", { num: toolTipData ?.data ?.installment}) : t("only cash")} 
                                                </Col>
                                                {/* <Col md={6} className="p-0 fw-bold mb-2">
                                                    <span className="font-size-14 pe-2 ">{t("developer")} </span>
                                                </Col>
                                                <Col md={6} className='fw-bold d-flex justify-content-end p-0'>
                                                    <span className="font-size-14 text-decoration-underline">{developer ?.name[`${AuthData.lang}`] ? developer ?.name[`${AuthData.lang}`] :
                                                                developer ?.name ?.en}</span>
                                                </Col> */}
                                                <Col md={6} className="p-0 fw-bold mb-2">
                                                    <span className="font-size-14 pe-2 ">{t("Available Units")} </span>
                                                </Col>
                                                <Col md={6} className='fw-bold d-flex justify-content-end p-0'>
                                                    <span className="font-size-14 text-decoration-underline">{toolTipData?.data?.units_count}</span>
                                                </Col>
                                                <Col md={6} className="p-0 fw-bold mb-2">
                                                    <span className="font-size-14 pe-2 ">{t("Min Sizes")} </span>
                                                </Col>
                                                <Col md={6} className='fw-bold d-flex justify-content-end p-0'>
                                                    <span className="font-size-14 text-decoration-underline">{Math?.min(...modeData?.images?.filter(res=> toolTipData?.id == res?.constrains?.id)[0]?.shapes?.map(item=> item?.hotspot?.data?.size))}</span>
                                                </Col>
                                            </Row>

                                            {toolTipData ?.data ?.unit_types?.filter((obj, index, self) => {
                                                return index === self.findIndex((o) => o.en === obj.en);
                                            })?.map((unit, index) => {
                                                return (
                                                    <Badge key={index} className="bgBadge font-size-12">{unit[`${AuthData.lang}`] ? unit[`${AuthData.lang}`] : unit ?.en}</Badge>
                                                )
                                            })}
                                        </CardBody>
                                    </Card>
                                    : toolTipData ?.type === "unit" ?
                                        <Card className="comCard">
                                            {modeData.images?.filter(img=> img.constrains?.id == toolTipData?.id)[0].images?.length > 0 ?
                                                <CardImg src={modeData.images?.filter(img=> img.constrains?.id == toolTipData?.id)[0]?.images[0].path}></CardImg>
                                                // <CardImg src={activeCardImg}></CardImg>
                                                :
                                                <CardImg src={compoundImg}></CardImg>
                                            }
                                            {developer ?.media ?.path ? <img src={developer.media.path} className='imgAbsolute' /> :
                                                <img src={developerdImg} className='imgAbsolute' />}
                                            <CardBody>
                                                <Badge className="bgBadgeResale  badgeAbsolute font-size-12">{toolTipData ?.data ?.unit_types[`${AuthData.lang}`] ? toolTipData ?.data ?.unit_types[`${AuthData.lang}`] : toolTipData ?.data ?.unit_types ?.en}</Badge>
                                                <div className="maxBodyHeight" style={{ height: "8rem" }}>
                                                    <CardText tag="h4" className="font-size-16" style={{ color: "#3a3335", fontWeight: 800 }}>{toolTipData ?.data ?.name[`${AuthData.lang}`] ? toolTipData ?.data ?.name[`${AuthData.lang}`] : toolTipData ?.data ?.name ?.en}</CardText>
                                                    <CardText tag="h4" className="mb-1">
                                                        <span className="font-size-16">{toCurrency(toolTipData ?.data ?.starting_from)} {t("egp")}</span>
                                                    </CardText>
                                                    <div className="d-flex ">
                                                        <p className="w-100 text-black icon_container"><i className="fa me-1 fa-bed"></i>{toolTipData ?.data ?.bedrooms} {t("beds")}</p>
                                                        <p className="w-100 text-black icon_container"><i className="fa me-1 fa-shower"></i>{toolTipData ?.data ?.bathrooms} {t("baths")}</p>
                                                        <p className="w-100 text-black icon_container"><i className="fa me-1 fa-exchange-alt"></i>{parseInt(toolTipData ?.data ?.size).toFixed(0)} {t("sqm")}</p>
                                                    </div>
                                                    <p className="w-100 text-black icon_container"><i className="fa me-1 fa-home"></i> {t("floor number")} {toolTipData?.floor}</p>
                                                    <p className="w-100 text-black my-0">
                                                        <i className="fas me-1 fa-map-marker-alt"></i>
                                                        {city[`${AuthData.lang}`] ? city[`${AuthData.lang}`] : city ?.en},
                                                        {address[`${AuthData.lang}`] ? address[`${AuthData.lang}`] : address ?.en},
                                                        {area[`${AuthData.lang}`] ? area[`${AuthData.lang}`] : area ?.en}
                                                    </p>
                                                </div>
                                                <div className="d-flex  justify-content-between">
                                                    <div className=" w-100">
                                                        <button className="w-100 btn btnMessage text-center'" onClick={(e) => {
                                                            e.stopPropagation() 
                                                            setCallModal(true)
                                                            setCallTypeModal('unit')
                                                            let unit = allUnits?.filter(unit=> unit.id == toolTipData.id)
                                                            let sales_rep = unit[0].sales_rep
                                                            setPhone(sales_rep?.phone)
                                                        }} >
                                                            <i className="fas fa-phone-alt"></i> {t("call")}
                                                        </button>
                                                    </div>
                                                    <div className=' w-100 mx-2'>
                                                        <button className="w-100 btn btnMessage text-center" onClick={(e) => {
                                                            e.stopPropagation()
                                                            setCallTypeModal('unit')
                                                            setMessageModal(true)
                                                            setUnit(toolTipData.data)
                                                        }}  >
                                                            <i className="fa fa-envelope"></i>
                                                        </button>
                                                    </div>
                                                    {interestLoading ?
                                                        <div className="w-100 d-flex justify-content-center pt-2">
                                                            <Spinner size="sm" color="primary" />
                                                        </div> : <div className='w-100'>
                                                            <button className='w-100 btn btnMessage text-center' onClick={(e) => {
                                                            e.stopPropagation()
                                                            interestHandler( toolTipData ?.data?.id)
                                                            }}>
                                                                {isInterested(toolTipData ?.data?.id) ? <i className="fas fa-heart text-danger"></i> :
                                                                    <i className="far fa-heart text-danger"></i>}
                                                            </button>
                                                        </div>}
                                                </div>
                                                <div className='mt-2'>
                                                    <button className='btn btn-primary w-100 text-center' onClick={() => {
                                                        toggleFullscreen()
                                                        history.push(`/property-details/${toolTipData ?.data ?.id}`)
                                                        dispatch(appendFilters({from: 'interactive'}))
                                                    }}>
                                                        {t('Buy Now')}
                                                    </button>
                                                </div>
                                            </CardBody>
                                        </Card> : null }
                        </div>
                    </div>

                </div>

                {/* <SkeletonTheme >
                    <Skeleton height= "89vh" width= '97vw' className="mx-4" ></Skeleton>
                </SkeletonTheme> */}
                <div id='loader'>
                    <Spinner2></Spinner2>
                </div>
                <canvas id={`canvas`}></canvas>

                {/* {(activeCanvas ?.constrains ?.type === "unit" && (loading < activeCanvas?.images?.length) ) && <SkeletonTheme >
                    <div style={{
                        position: 'absolute', zIndex: '9999999',
                        background: '#FFF', overflow:'auto',
                        top: '0', left: '0', 
                        paddingBottom: '24px',
                        width: '100%', height:activeCanvas?.images?.length > 3 ? `${(Math.ceil(activeCanvas.images?.length/3) * 450) + 24}` : '100%' }}>
                        <div className="images w-50 m-auto">
                            {!!activeCanvas?.images && activeCanvas?.images?.map((_, index) =>{
                                return <Skeleton 
                                            key={index}
                                            inline={true}
                                            width= {index % 3 == 0 ? '99%' : '49%'}
                                            height= {index % 3 == 0 ? '300px' : '150px'}
                                            style={{ margin: '5px 0.5%' }}
                                        />
                            })}
                        </div>
                    </div>
                </SkeletonTheme>} */}

                {/* {(activeCanvas ?.constrains ?.type === "unit" && !!openImage) && <button
                    className="close-image"
                    onClick={() => setOpenImage(null)}>
                    <i className="fas fa-times"></i>
                </button>} */}
            </Col>
 
            {activeCanvas ?.constrains ?.type === "unit" && <div 
                    className="images-div"
                    style={{
                    position: 'absolute', zIndex: '9999',
                    background: '#FFF', overflow:'hidden',
                    top: '0', left: '12px', 
                    width: '100vw', height: '100vh' }}>
                        <div className="d-flex p-5 justify-content-between align-items-center">
                            <div>
                                <button className="btn text-center font-size-18">
                                {isInterested(activeCanvas.constrains?.id) ? <i className="fas fa-heart text-danger"></i> :
                                    <i className="far fa-heart text-danger"></i>}
                                </button>
                                <button className="btn text-center font-size-18">
                                    {/* <i className="fas fa-share-alt"></i> */}
                                    <i className="fas fa-external-link-alt"></i>
                                </button>
                            </div>
                            <div className="font-size-18 text-bold" style={{fontWeight: '600'}}>
                                {`${openImage+1} / ${activeCanvas?.images?.length}`}
                            </div>
                            <div>
                                <button className="font-size-18 border-0" style={{background: 'none'}}
                                onClick={()=>{
                                    const canvasTarget = modeData.images.find(item => {
                                        if(!activeCanvas.comesForm?.id){
                                            return item?.id === modeData.masterImg?.id
                                        }
                                        return item?.id === activeCanvas.comesForm?.id
                                    })
                                    let updateShapes = canvasTarget?.shapes?.filter(img=> {
                                        if(img.hotspot?.type == 'unit'){
                                            let isExist = allUnits.filter(unit => unit.id == img?.hotspot.id)
                                            if(isExist.length > 0){
                                                return img
                                            }
                                        } else {
                                            let isExist = allUnits.filter(unit => img?.hotspot?.units?.some(res=> res == unit.id))
                                            if(isExist.length > 0){
                                                return img
                                            }
                                        }
                                    })
                                    setActiveCanvas({ ...canvasTarget, shapes: updateShapes })
                                }}>
                                   {t('close')}
                                    <li className="fas fa-times mx-2"></li>
                                </button>
                            </div>
                        </div>
                        <div style={{
                            height: 'calc(100vh - 140px)',
                            padding: '2rem',
                            textAlign: 'center'
                        }}>
                           {openImage > 0 && <button
                                type="button"
                                className="arrow-buttons"
                                onClick={() => setOpenImage(prev=> prev-1)}
                                style={{ left: "20px" }}>
                                <i className="fas fa-chevron-left fa-2x "
                                style={{
                                    padding: '10px 15px',
                                    border: '1px solid',
                                    borderRadius: '50%'
                                }}></i>
                            </button>}
                            <img 
                                src={activeCanvas?.images[openImage]?.path} 
                                style={{
                                    height: '100%'
                                    // position: 'absolute',
                                    // top: '50%', left: '50%',
                                    // transform: 'translate(-50%, -50%)'
                                }}
                                alt='image' />
                            {openImage < activeCanvas.images?.length-1 &&<button
                                onClick={() => setOpenImage(prev=> prev+1)}
                                className='arrow-buttons'
                                style={{ right: "60px" }}>
                                <i 
                                    style={{
                                        padding: '10px 15px',
                                        border: '1px solid',
                                        borderRadius: '50%'
                                    }}
                                    className="fas fa-chevron-right fa-2x" >
                                </i>
                            </button>}
                        </div>
            </div>}

            {callModal && <CallModal modal={callModal} setModal={setCallModal} callTypeModal={callTypeModal} phone={phone} />}
            {messageModal && <MessageModal modal={messageModal} setModal={setMessageModal} item={unit}  type={callTypeModal} />}
        </Row>
        
        </>
    )
}

const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(number);
}

export default UserMode